import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

import Button from '../Button';

export const Container = styled.div`
	display: inline-flex;
	justify-content: center;
	align-items: center;
	flex-direction: row;
	padding: 0 var(--spacing-4);
	border: 1px solid;
	border-radius: 400px;
	gap: var(--spacing-2);
	width: 100%;
	max-width: max-content;
	height: 4rem;

	@media ${Breakpoints.mobile} {
		padding: var(--spacing-1) var(--spacing-2);

		.typography {
			text-overflow: ellipsis !important;
			white-space: nowrap !important;
		}
	}
`;

export const ShipmentStatusButton = styled(Button)`
	padding: 0 !important;
	border: 0 !important;
	border-radius: 400px !important;
	max-width: max-content;
`;
